import { toast } from 'sonner'

//
// 操作フィードバック（トースト）の唯一の入口。
//
// 画面から `sonner` を直接呼ばずここを経由させるのは、
// 1. 文言の粒度（message = 何が起きたか / description = 次に何をすればよいか）を揃えるため
// 2. トーストの実装（現在は sonner）を差し替えても呼び出し側が変わらないようにするため
//
// **使いどころ**: 保存・削除・一括更新など mutation を伴うボタンの結果表示。
// 失敗時は「何が失敗したか」に加えて description で次の一手（再試行・入力の見直し）を示す。
//
// **トーストだけで済ませてはいけない場合**: 件数・失敗理由など、あとから確認したい情報は
// DOM に残る形（ResultBanner・取込結果パネル）でも示す。トーストは数秒で消えるため、
// それ単独では自動テストからも人間からも「結果」を確定できない
// （docs/develop/client_ui/ui_verification.md「操作結果を機械可読で確定できるようにする」）。
//
export const notify = {
  success(message: string, description?: string) {
    toast.success(message, { description })
  },
  error(message: string, description?: string) {
    toast.error(message, { description })
  },
  warning(message: string, description?: string) {
    toast.warning(message, { description })
  },
  info(message: string, description?: string) {
    toast.info(message, { description })
  },
  // 表示中のトーストを全て閉じる。sonner のトーストはモジュールグローバルな store に積まれ、
  // 画面（story）を切り替えても残るため、storybook の preview はここで毎回リセットする
  dismissAll() {
    toast.dismiss()
  },
}
